<template>
  <footer class="content">
    <div class="sns">
      <a href="https://www.facebook.com/nagasakigoto/?ref=br_rs" target="_blank" class="icon fb"><img height="25" src="../assets/facebook-f-brands.svg" alt=""></a>
      <a href="https://www.instagram.com/nagasakigoto510/?hl=ja" target="_blank" class="icon instagram"><img height="25" src="../assets/instagram-brands.svg" alt=""></a>
      <a href="https://line.me/R/ti/p/%40nagasakigoto" target="_blank" class="icon line"><img height="25" src="../assets/line-brands.svg" alt=""></a>
    </div>
    <div class="copy">
      <p>
        © GOTO, Inc. All rights reserved.
      </p>
    </div>
    
  </footer>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style scoped>
.copy{
  font-size: 12px;
  position: relative;
  flex-basis: 70%;
}
.copy p{
  position: absolute;
  bottom: 0;
  margin-bottom: 0;
}
.content{
  margin-top: 140px;
  padding: 80px 40px 40px;
  border-top: 1px solid #000;
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  vertical-align: bottom;
  background: url(../assets/footer_logo.png) center 70px no-repeat;
  -webkit-background-size: 80px auto;
  background-size: 80px auto;
}
.logo{
  text-align: center;
}
.logo img{
  width: 70px;
}
.sns{
  display: flex;
  text-align: right;
  justify-content: flex-end;
  vertical-align: bottom;
  padding-top: 10px;
  flex-basis: 30%;
}
.icon{
  width: 50px;
  height: 50px;
  line-height: 43px;
  border: 1px solid #000;
  text-align: center;
  border-radius: 50%;
  margin-left: 10px;
}
@media screen and (max-width:650px){
  .content{
    padding-top: 130px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
    margin-top: 80px;
    background-position: center 40px;
  }
  
}
@media screen and (max-width:480px){
  .icon{
    width: 40px;
    height: 40px;
    line-height: 34px;
  }
  .copy{
    line-height: 1.2;
    margin-bottom: 10px;
  }
  .icon img{
    height: 20px;
  }
}
@media screen and (max-width:390px){
  .content{
    display: block;
    padding-top: 120px;
    padding-bottom: 0;
  }
  .copy, .sns{
    width: 100%;
    text-align: center;
  }
  .icon{
    margin: 0 5px;
  }
  .sns{
    display: block;
    margin-bottom: 10px;
  }
  .sns a{
    display: inline-block;
  }
  .copy p{
    position: static;
  }
}
</style>
